import React from 'react';

import { Grid, Typography, Switch } from '@gogame/components';
import { FormFieldArray, withFormField, FormFieldGroup } from '@gogame/form';

import {
  ConditionsPicker,
  TimeLimitInput,
} from 'scenes/PromoCodes/components/PromoCodesForm/components';
import {
  CONDITIONAL_REWARDS,
  CONDITIONAL_REWARDS_TIMER,
  APPLICATION,
  CONDITIONS,
  IS_TIME_LIMITED,
  CUSTOM_TIMER,
  TIMER,
} from 'scenes/PromoCodes/constants';

import ConditionalRewardCard from './ConditionalRewardCard';

const TimeLimitSwitch = withFormField({ padding: 0 })(
  ({ name, value = {}, onChange }) => {
    const conditionalRewards = value[CONDITIONAL_REWARDS] || [];

    const handleChange = (_e, val) => {
      let result = {
        ...value,
        [IS_TIME_LIMITED]: val,
        [CONDITIONAL_REWARDS_TIMER]: null,
        [CONDITIONAL_REWARDS]: conditionalRewards.map((conditionalReward) => {
          return {
            ...conditionalReward,
            [CUSTOM_TIMER]: {
              [IS_TIME_LIMITED]: false,
              [TIMER]: null,
            },
          };
        }),
      };

      onChange(_e, result);
    };

    return (
      <Switch
        name={name}
        label={'Limit completion time'}
        checked={value?.[IS_TIME_LIMITED]}
        disabled={!conditionalRewards.length}
        onChange={handleChange}
      />
    );
  }
);

const ConditionalRewards = ({ conditions, rewards, name, values, loading }) => {
  const disabled = !values[APPLICATION];
  const isInputVisible = values?.[CONDITIONS]?.[IS_TIME_LIMITED];

  return (
    <Grid container spacing={3}>
      <Grid item>
        <TimeLimitSwitch name={name} />
      </Grid>
      {isInputVisible && (
        <Grid item xs={3}>
          <div style={{ width: '185px' }}>
            <TimeLimitInput
              name={name}
              valuePropKey={CONDITIONAL_REWARDS_TIMER}
            />
          </div>
        </Grid>
      )}
      <Grid item container xs={12} spacing={3}>
        <FormFieldGroup name={name} disabled={disabled}>
          <FormFieldArray name={`${name}.${CONDITIONAL_REWARDS}`}>
            {({ value, push, remove, error }) => {
              return (
                <>
                  {error && (
                    <Grid item xs={12}>
                      <Typography color={'error'}>{error}</Typography>
                    </Grid>
                  )}
                  {value && (
                    <Grid container item xs={12} spacing={3}>
                      {value?.map((condition, index) => {
                        return (
                          <Grid item xs={12} key={index}>
                            <ConditionalRewardCard
                              name={`${CONDITIONAL_REWARDS}.[${index}]`}
                              title={condition.name || condition.typeName}
                              onRemove={() => remove(index)}
                              rewards={rewards}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                  <Grid item xs={6}>
                    <ConditionsPicker
                      value={value}
                      options={conditions || []}
                      onChange={([{ id, ...condition } = {}] = []) => {
                        push({
                          ...condition,
                          type: id,
                        });
                      }}
                      disabled={disabled}
                      loading={loading}
                    />
                  </Grid>
                </>
              );
            }}
          </FormFieldArray>
        </FormFieldGroup>
      </Grid>
    </Grid>
  );
};

export default ConditionalRewards;
